import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { Ribbon } from '@woovi/ui';
import { centsToFloat, withMask } from '@woovi/utils';

import type { PaymentLinkActiveCashbackFidelityBalance_charge$key } from './__generated__/PaymentLinkActiveCashbackFidelityBalance_charge.graphql.ts';

import type { ReactNode } from 'react';

type PaymentLinkActiveCashbackFidelityBalanceProps = {
  charge: PaymentLinkActiveCashbackFidelityBalance_charge$key;
};

const PaymentLinkActiveCashbackFidelityBalance = (
  props: PaymentLinkActiveCashbackFidelityBalanceProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const charge =
    useFragment<PaymentLinkActiveCashbackFidelityBalance_charge$key>(
      graphql`
        fragment PaymentLinkActiveCashbackFidelityBalance_charge on Charge {
          customer {
            cashbackFidelityBalance
          }
        }
      `,
      props.charge,
    );

  if (!charge?.customer?.cashbackFidelityBalance) {
    return null;
  }

  const balance = withMask(
    centsToFloat(charge.customer.cashbackFidelityBalance),
  );

  return (
    <Ribbon>
      <Typography>🤑</Typography>
      <Typography color={theme.palette.tertiary.main} sx={{ fontSize: '16px' }}>
        <Trans t={t} i18nKey={'You have {{balance}} of cashback!'}>
          You have <b>{{ balance }}</b> of cashback!
        </Trans>
      </Typography>
    </Ribbon>
  );
};

export default PaymentLinkActiveCashbackFidelityBalance;
